/* eslint-disable @typescript-eslint/no-explicit-any */
import { Directive, effect, Inject, input, Self } from '@angular/core';
import { Wrapper } from './wrapper.interface';
import { WRAPPER_TOKEN } from './wrapper.tokens';

@Directive({
    selector:   '[config]',
    standalone: false
})
export class VConfigDirective {
  config = input.required<unknown>();
  constructor(@Self() @Inject(WRAPPER_TOKEN) private component: Wrapper<any>) {
    effect(() => this.component.configInput.set(this.config()));
  }
}